export default __webpack_public_path__ + "static/media/Wrong.ea1fa8a8.wav";